import * as React from 'react';
import { Link } from 'react-router-dom';

import { addModifiers } from '../../../shared/helpers';

interface LinkPanel {
  url: string;
  label: any;
  icon: boolean;
  color?: 'back-blue' | 'back' | 'strong';
}

interface ContentLinkProps extends LinkPanel {
  modifiers?: string[];
}

interface PanelHeaderProps {
  title: string;
  titleModifiers: string[];
  firstLink?: LinkPanel;
  nextLink?: LinkPanel;
  contentLink?: ContentLinkProps;
}

export const PanelHeader = ({ title, titleModifiers, firstLink, nextLink, contentLink }: PanelHeaderProps) => {
  const modifiersBack = firstLink && firstLink.color ? [firstLink.color] : ['back'];

  return (
    <div>
      {(firstLink || nextLink) && (
        <div className="panel__header__links">
          {firstLink && firstLink.url && (
            <Link className={addModifiers('panel__header__links', modifiersBack)} to={firstLink.url}>
              {firstLink.icon && <span className="panel__header__links--back--icon" />}
              {firstLink.label}
            </Link>
          )}
          {nextLink && nextLink.url && (
            <Link
              className={addModifiers('panel__header__links', nextLink.label.includes('Next') ? ['next'] : ['next-orange'])}
              to={nextLink.url}
            >
              {nextLink.label}
              {nextLink.label.includes('Next') && <span className="panel__header__links--next--icon" />}
            </Link>
          )}
        </div>
      )}
      <header className="panel__header">
        {title && <h2 className={addModifiers('panel__header-title', titleModifiers)}>{title}</h2>}
        {contentLink && (
          <Link to={contentLink.url} className={addModifiers('button', contentLink.modifiers)}>
            {contentLink.label}
          </Link>
        )}
      </header>
    </div>
  );
};
